"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactAria = require("react-aria");
var _FocusRing = require("../../../shared/utility-components/FocusRing");
var _input = require("./input.tokens");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _Input = require("./Input.common");
var _jsxRuntime = require("react/jsx-runtime");
var TextField = function TextField(_ref) {
  var value = _ref.value,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _input.TextFieldSize.LARGE : _ref$size,
    sizeInCharacters = _ref.sizeInCharacters,
    allowedCharactersRegex = _ref.allowedCharactersRegex,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? _input.TextFieldWidth.FLEX : _ref$width,
    placeholder = _ref.placeholder,
    label = _ref.label,
    dataCy = _ref['data-cy'],
    dataUserpilot = _ref['data-userpilot'],
    disabled = _ref.disabled,
    errorMessage = _ref.errorText,
    hasError = _ref.hasError,
    description = _ref.helperText,
    isPasswordField = _ref.isPasswordField,
    maxLength = _ref.maxLength,
    autoComplete = _ref.autoComplete,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onValueChange = _ref.onValueChange;
  var ref = _react.default.useRef(null);
  var _ref2 = (0, _reactAria.useTextField)({
      label: label,
      placeholder: placeholder,
      isDisabled: disabled,
      errorMessage: errorMessage,
      description: description,
      value: value
    }, ref),
    labelProps = _ref2.labelProps,
    inputProps = _ref2.inputProps,
    descriptionProps = _ref2.descriptionProps,
    errorMessageProps = _ref2.errorMessageProps;
  var onChangeHandler = function onChangeHandler(e) {
    if (allowedCharactersRegex) {
      var regex = new RegExp(allowedCharactersRegex);
      if (!regex.test(e.target.value)) {
        return;
      }
    }
    if (onValueChange) {
      onValueChange(e.target.value);
    }
    if (onChange) {
      onChange(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoDisplayWrapper.InfoDisplayWrapper, {
    label: label,
    ariaLabelProps: labelProps,
    helperText: description,
    ariaHelpTextProps: descriptionProps,
    errorText: errorMessage,
    ariaErrorTextProps: errorMessageProps,
    "data-cy": dataCy,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusRing.FocusRing, {
      isTextInput: true,
      isFlex: true,
      mouseFocus: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, _objectSpread({}, inputProps, {
        hasError: !!errorMessage || hasError,
        height: size,
        width: width,
        ref: ref,
        onChange: onChangeHandler,
        onBlur: onBlur,
        "data-cy": dataCy,
        "data-userpilot": dataUserpilot,
        type: isPasswordField ? 'password' : 'text',
        maxLength: maxLength,
        size: sizeInCharacters,
        autoComplete: autoComplete
      }))
    })
  });
};
TextField.SIZE = _input.TextFieldSize;
TextField.WIDTH = _input.TextFieldWidth;
TextField.REGEX = {
  ALPHANUMERIC: '^[a-zA-Z0-9]*$',
  ALPHABETIC: '^[a-zA-Z]*$',
  NUMERIC: '^[0-9]*$'
};
var _default = exports.default = TextField;